$(function () {
    var menuButton = $('#menuButton');
    var navMenu = $('#navMenu');

    menuButton.on('click', function () {
        $(this).toggleClass('active');
        navMenu.toggleClass('show-navbar');
    });
});
